import React from 'react';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import './src/style/index.css';

const theme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 },
  },
  palette: {
    primary: { main: '#3f51b5' },
    secondary: { main: '#f50057' },
  },
});

export const wrapRootElement = ({ element }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      {element}
    </ThemeProvider>
  </StyledEngineProvider>
);
